var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5B300",
    fillRule: "evenodd",
    d: "M12.058 11.748l1.274 4.113-3.331-2.543-3.332 2.543 1.273-4.113-3.334-2.544H8.73L10 5.09l1.272 4.114h4.119l-3.333 2.544zm2.928-6.595L10 0 5.014 5.153C3.469 6.776 0 10.82 0 14.947c0 2.704 2.087 4.925 4.661 4.925 1.708 0 3.117-.854 3.984-2.306.135-.228.271-.285.434-.285.243 0 .406.2.406.541 0 1.082-.976 4.954-4.12 6.178h9.27c-3.144-1.224-4.12-5.096-4.12-6.178 0-.341.163-.54.406-.54.163 0 .299.056.434.284.867 1.452 2.276 2.306 3.984 2.306 2.574 0 4.661-2.22 4.661-4.925 0-4.128-3.469-8.171-5.014-9.794z"
  })));
}
SvgIconMenu.displayName = 'IconMenu';
export default SvgIconMenu;